module.exports = __webpack_public_path__ + "static/media/member2.4ea84737.jpg";